import { View, Text, TextInput, ScrollView, ActivityIndicator, Platform, Keyboard } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { useRoute } from '@react-navigation/native'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { ThemedView, ThemedText, Theme } from '@app/theme'
import CommonHeader from '@app/sharedComponents/Header/Header'
import { searchIFSC } from './bankBranchService'
import InputText from '@app/sharedComponents/TextInput/TextInput'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import { useStepperData } from '@app/hooks/useStepperData'
import { useTheme } from '@shopify/restyle'
import Stepper from '@app/sharedComponents/Stepper/Stepper'
import SearchIcon from '@app/assets/svg/SearchIcon'
import { trackEvent } from '@app/utils/amplitude'


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'BANK_BRANCH_SEARCH'>;

const BankBranchSearch = ({ route, navigation }: ScreenProps) => {
    const { bankCode } = route.params
    const [searchText, setSearchText] = useState('')
    const [searchResults, setSearchResults] = useState({})
    const { stepperData, isLoading } = useStepperData()
    const { colors } = useTheme<Theme>()

    const [isSearching, setIsSearching] = useState(false)

    const ref = useRef<TextInput>(null)

    useEffect(() => {
        if (Platform.OS !== 'web' && !isLoading) {
            const timeout = setTimeout(() => {
                if (ref?.current) {
                    // Keyboard.dismiss()
                    ref?.current?.focus()
                }
            }, 500)

            return () => {
                clearTimeout(timeout)
            }
        }
    }, [isLoading])


    useEffect(() => {
        setIsSearching(true)

        if (searchText.length === 0) {
            setSearchResults({})
            return
        }

        if (searchText.length < 3) {
            return
        }

        const timer = setTimeout(async () => {

            try {
                const response = await searchIFSC({ bankCode, searchText })
                setSearchResults(response)
            } catch (error) {
                console.error(error)
            } finally {
                setIsSearching(false)
            }
        }, 300)

        return () => {
            clearTimeout(timer)
        }
    }, [searchText])

    if (isLoading) {
        return <ThemedView justifyContent='center' alignItems='center' flex={1} bg='bg-surface-primary'>
            <ActivityIndicator size={12} color={colors['text-action-primary']} />
        </ThemedView>
    }




    return (
        <ThemedView flex={1} bg='bg-surface-primary'>
            <CommonHeader hideBottomBorder label='Search branch or IFSC' navigation={navigation} pageName={route.name} />
            <Stepper stepperData={stepperData} />
            <ThemedView flex={1} bg='bg-surface-primary'>
                <ScrollView keyboardShouldPersistTaps="handled">
                    <ThemedView padding='lg' paddingTop='2xl'>
                        <InputText
                            ref={ref}
                            placeHolder={'Search by branch or IFSC'}
                            keyboardType="default"
                            showLabel={true}
                            autoFocus={Platform.OS === 'web'}
                            value={searchText}
                            label='Search'
                            showAnimation
                            isDarkMode={false}
                            onChangeText={(e) => {
                                if (e !== " ") {
                                    setSearchText(e)
                                }
                            }}
                            showErrorMessage={false}
                            showErrorMessageInFocus={true}
                            rightAccessory={() => <SearchIcon size={24} color={colors['icon-primary']} />}
                            showRightAccessory={true}
                        />
                        {searchText?.length > 3 && Object.keys(searchResults).length === 0 ? (
                            <ThemedView flex={1} justifyContent='center' alignItems='center' mt='2xl' padding='lg'>
                                {!isSearching && (
                                <ThemedText variant='b3r'>No results found</ThemedText>
                                )}
                            </ThemedView>
                        ) : (
                            <ThemedView flex={1}>
                                {Object.keys(searchResults).map((key) => (
                                    <ThemedTouchableOpacity onPress={() => {  
                                        trackEvent('ADDBANK_IFSC_SELECTED', {IFSC : key})
                                        navigation.navigate('BANK_ACCOUNT_ADD', { bankCode, bankName: (searchResults as Record<string, { ADDRESS: string  , BANK: string }>)[key]?.BANK , ifsc : key })
                                    }}>
                                        <ThemedView borderBottomWidth={1} paddingVertical='lg' borderColor='border-secondary' key={key}>
                                            <ThemedText mb='sm' variant='b3b'>{key}</ThemedText>
                                            <ThemedText variant='b3r'>{(searchResults as Record<string, { ADDRESS: string }>)[key]?.ADDRESS}</ThemedText>
                                        </ThemedView>
                                    </ThemedTouchableOpacity>
                                ))}
                            </ThemedView>
                        )}

                    </ThemedView>
                </ScrollView>
            </ThemedView>
        </ThemedView>
    )
}

export default BankBranchSearch